import React, { createContext, useContext, useState, useEffect } from 'react';

const OnboardingContext = createContext();

export const useOnboarding = () => {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error('useOnboarding must be used within OnboardingProvider');
  }
  return context;
};

export const OnboardingProvider = ({ children }) => {
  const [onboardingCompleted, setOnboardingCompleted] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [showOnboarding, setShowOnboarding] = useState(false);

  useEffect(() => {
    // localStorage에서 온보딩 완료 여부 확인
    const completed = localStorage.getItem('onboarding_completed') === 'true';
    setOnboardingCompleted(completed);
    
    // 완료하지 않았으면 온보딩 표시
    if (!completed) {
      setShowOnboarding(true);
    }
  }, []);

  const completeOnboarding = () => {
    localStorage.setItem('onboarding_completed', 'true');
    setOnboardingCompleted(true);
    setShowOnboarding(false);
  };

  const skipOnboarding = () => {
    completeOnboarding();
  };

  const nextStep = () => {
    setCurrentStep(prev => prev + 1);
  };

  const prevStep = () => {
    setCurrentStep(prev => Math.max(0, prev - 1));
  };

  const resetOnboarding = () => {
    localStorage.removeItem('onboarding_completed');
    setOnboardingCompleted(false);
    setCurrentStep(0);
    setShowOnboarding(true);
  };

  return (
    <OnboardingContext.Provider
      value={{
        onboardingCompleted,
        currentStep,
        showOnboarding,
        completeOnboarding,
        skipOnboarding,
        nextStep,
        prevStep,
        resetOnboarding,
        setShowOnboarding
      }}
    >
      {children}
    </OnboardingContext.Provider>
  );
};

